import { render, staticRenderFns } from "./customerTag.vue?vue&type=template&id=92e2f274&scoped=true"
import script from "./customerTag.vue?vue&type=script&lang=js"
export * from "./customerTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92e2f274",
  null
  
)

export default component.exports